import { ViewScopeInfo } from "@/explore/ViewScopeStore"
import { useViewPersonStore } from "@/rd/ViewPersonStore"
import { usePlaceStore } from "@/rd/PlaceStore"

export function usePlaceAnalysis() {
    const viewPersonStore = useViewPersonStore()
    const placeStore = usePlaceStore()

    function *getScopeCountryCodes(scopeInfo: ViewScopeInfo) {
        for (const id of scopeInfo.personIds) {
            const vp = viewPersonStore.getLoadedPerson(id)
            const placeId = vp?.displayProperties?.birthPlaceId
            const place = placeStore.trackAsyncPlace(placeId)?.data
            const countryCode = place?.countryCode
            if (countryCode) {
                yield countryCode
            }
        }
    }

    return {
        getScopeCountryCodes,
    }
}
